import { Button, Col, Modal, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import { InputNumber } from 'antd';
import PhoneList from '../../pages/Attribute/PhoneList';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ModalConfiguration = ({
  setShow,
  show,
  sendRpc,
  timeTransfer1,
  setTimeTransfer1,
  curTimeTransfer1,
  timeTransfer2,
  setTimeTransfer2,
  curTimeTransfer2,
  timeTransfer3,
  setTimeTransfer3,
  curTimeTransfer3,
  pressureMax,
  setPressureMax,
  sendFail,
  setSendFail,
  index,
  label,
  data,
}) => {
  const { t } = useTranslation();
  const { device_id } = useParams();
  const [isEdit, setIsEdit] = useState(false);

  const toggleEdit = () => {
    document.querySelector('.btn__edit').innerHTML = t('update');
    document.querySelector('.btn__edit-title').innerHTML =
      t('customize') + ' (*)';
    setIsEdit(true);
  };

  const handleSubmitConfiguration = () => {
    setShow(false);
    if (!pressureMax) {
      const config = {
        setTime1: timeTransfer1,
        setTime2: timeTransfer2,
        setTime3: timeTransfer3,
      };
      sendRpc('setConfiguration', config);
    } else {
      sendRpc('pressureMax' + (index + 1), pressureMax[index]);
    }
    setIsEdit(false);
  };

  useEffect(() => {
    if (sendFail) {
      setTimeTransfer1(curTimeTransfer1);
      setTimeTransfer2(curTimeTransfer2);
      setTimeTransfer3(curTimeTransfer3);
      setSendFail(false);
    }
  }, [sendFail]);

  const handleClose = () => {
    if (!pressureMax) {
      setTimeTransfer1(curTimeTransfer1);
      setTimeTransfer2(curTimeTransfer2);
      setTimeTransfer3(curTimeTransfer3);
    }
    setIsEdit(false);
    setShow(false);
  };

  return (
    <Modal onHide={handleClose} show={show} scrollable size="md">
      <Modal.Header closeButton>
        <Modal.Title className="btn__edit-title">{t('customize')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!pressureMax ? (
          <>
            <Row style={{ marginBottom: '10px' }}>
              <Col lg={7}>
                <p>{t('rotation-time')}</p>
              </Col>
              <Col lg={5}>
                <div>
                  <InputNumber
                    size="large"
                    value={timeTransfer1}
                    readOnly={!isEdit}
                    min={0}
                    onChange={(e) => {
                      setTimeTransfer1(e);
                    }}
                    addonAfter={t('second')}
                  />
                </div>
              </Col>
            </Row>
            <Row style={{ marginBottom: '10px' }}>
              <Col lg={7}>
                <p>{t('auto-flush-time')}</p>
              </Col>
              <Col lg={5}>
                <div>
                  <InputNumber
                    size="large"
                    type='number'
                    value={timeTransfer2}
                    readOnly={!isEdit}
                    min={0}
                    onChange={(e) => {
                      setTimeTransfer2(e);
                    }}
                    addonAfter={t('second')}
                  />
                </div>
              </Col>
            </Row>
            <Row style={{ marginBottom: '10px' }}>
              <Col lg={7}>
                <p>{t('RO-time')}</p>
              </Col>
              <Col lg={5}>
                <div>
                  <InputNumber
                    size="large"
                    value={timeTransfer3}
                    readOnly={!isEdit}
                    min={0}
                    onChange={(e) => {
                      setTimeTransfer3(e);
                    }}
                    addonAfter={t('second')}
                  />
                </div>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col lg={12}>
                <PhoneList
                  dataPhone={
                    data?.attributes?.phoneList
                      ? data?.attributes?.phoneList
                      : []
                  }
                  deviceId={device_id}
                />
              </Col>
            </Row>
          </>
        ) : (
          <Row style={{ marginBottom: '10px' }}>
            <Col lg={7}>
              <p>{t('warning-threshold') + ' ' + label}</p>
            </Col>
            <Col lg={5}>
              <div>
                <InputNumber
                  size="large"
                  defaultValue={parseFloat(pressureMax[index])}
                  readOnly={!isEdit}
                  style={{ width: '50px !important' }}
                  min={0}
                  onChange={(e) => {
                    let newPressureMax = [...pressureMax];
                    newPressureMax[index] = e;
                    setPressureMax(newPressureMax);
                  }}
                  addonBefore={t('max')}
                />
              </div>
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t('close')}
        </Button>
        <Button
          variant="primary"
          onClick={isEdit ? handleSubmitConfiguration : toggleEdit}
          className="btn__edit"
        >
          {t('edit')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfiguration;
